/**
 * Seitenweise Anzeige der Mängelliste: die Historie eines grossen Projekts
 * traegt ~600 erledigte Eintraege — alle auf einmal gemountet kostet jede
 * Eingabe spuerbar Zeit. Gesucht, gefiltert und sortiert wird weiter ueber
 * ALLE Eintraege; das Fenster schneidet erst danach ab.
 */

/** So viele Karten stehen zuerst — und so viele legt „Weitere anzeigen“ jeweils nach. */
export const KARTEN_SEITE = 50;

/** Fenster samt der Filterlage, fuer die es gilt (fensterLage). */
export interface KartenFenster {
    lage: string;
    anzahl: number;
}

/**
 * Schluessel der Filterlage (Modus, Abschnitt, Suche, Status, Thema). Aendert
 * er sich, beginnt das Fenster wieder bei KARTEN_SEITE.
 */
export function fensterLage(teile: readonly (string | null | undefined)[]): string {
    return JSON.stringify(teile.map(t => t ?? ''));
}

/** Das Fenster fuer die aktuelle Filterlage: gilt es fuer eine andere, wieder die ersten KARTEN_SEITE. */
export function fensterAnzahlFuer(fenster: KartenFenster, lage: string): number {
    return fenster.lage === lage ? fenster.anzahl : KARTEN_SEITE;
}

/**
 * Wie viele Karten der gefilterten, sortierten Liste stehen: das Fenster —
 * mindestens aber bis zur letzten Karte, die nie verdeckt werden darf (die
 * aufgeklappte, die gerade angelegte). Das Fenster waechst nur am Stueck, die
 * Reihenfolge bleibt die des PDFs.
 */
export function sichtbareKarten(liste: readonly { id: string }[], fenster: number, bleibtSichtbar: (id: string) => boolean): number {
    const anzahl = Math.min(Math.max(fenster, 0), liste.length);
    for (let i = liste.length - 1; i >= anzahl; i--) {
        if (bleibtSichtbar(liste[i].id)) return i + 1;
    }
    return anzahl;
}

/** Zahlen fuer die Knoepfe: wie viele „Weitere anzeigen“ nachlegt und wie viele insgesamt noch fehlen. */
export function restKarten(gesamt: number, sichtbar: number): { weitere: number; rest: number } {
    const rest = Math.max(0, gesamt - sichtbar);
    return { weitere: Math.min(KARTEN_SEITE, rest), rest };
}
